export const environment = (env) => {
  return process.env.NODE_ENV === env;
}

export const isProduction = environment('production');
export const isStaging = environment('staging');

function makeConfig(apiPath, wineCloudPath, pusherKey) {
  return {
    API_PATH: apiPath,
    WC_PATH: wineCloudPath,
    PUSHER_KEY: pusherKey
  };
}

const allConfigs = {
  production: makeConfig(
    'https://api.fermentsimulator.com.au',
    'https://thewinecloud.com.au',
    'e3f3c0ef7b852baa7401'
  ),
  staging: makeConfig(
    'http://api.awri.codium.com.au',
    'http://winecloud.projectstatus.in',
    '8027d5f83a3e5eaea4fc'
  ),
  default: makeConfig(
    'http://api.fermentsimulator.com.au', // 'http://api.awri.local',
    'http://thewinecloud.com.au', // 'http://winecloud.projectstatus.in',
  'e46a2030bdc6ee061be4'
  )
}

export const config =
  isProduction ? allConfigs['production'] :
    isStaging ? allConfigs['staging'] :
      allConfigs['default'];



// WEBPACK FOOTER //
// ./src/config.js